import {
  awaitAnimate,
  Particle,
  ParticleModes,
} from "../../../engine/anims/Particle";
import Colors from "../../Colors";

export const InvalidWordParticle = {
  mode: ParticleModes.DRAW_OVER_LAST,
  char: null,
  fg: Colors.RED,
  bg: null,
  animate: async (particle: Particle<string>) => {
    await awaitAnimate({
      driver: particle.driver,
      from: particle.options,
      to: Colors.RUST,
      duration: 100,
      onUpdate: (latest) => {
        particle.fg = latest;
      },
    });

    await new Promise((r) => setTimeout(r, 200));

    await awaitAnimate({
      driver: particle.driver,
      from: Colors.RUST,
      to: particle.options || Colors.RED,
      duration: 200,
      onUpdate: (latest) => {
        particle.fg = latest;
      },
    });
  },
};
